/**
 * Resolve an AssetRef to a URL the browser can load.
 *
 *   "r2://path/to/file"  →  "/assets/path/to/file"   (served by the Worker)
 *   "/foo.svg"           →  unchanged (from the static asset bundle)
 *   "https://…"          →  unchanged
 */
export function resolveAsset(ref: string): string {
  if (ref.startsWith("r2://")) {
    return "/bio-uploads/" + ref.slice("r2://".length);
  }
  return ref;
}
